import { defineComponent as _defineComponent } from 'vue'
import { twMerge } from 'tailwind-merge'

import { thumbnailImage } from '@/utils/utility-manager'

export interface LAvatarProps {
  src?: string
  fallback?: string
  thumbnailSize?: number
  twClass?: string | string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LAvatar',
  props: {
    src: { default: undefined },
    fallback: { default: undefined },
    thumbnailSize: { default: 128 },
    twClass: { default: undefined }
  },
  setup(__props: any) {



return { __sfc: true,twMerge, thumbnailImage }
}

})